const isDesktop = window.isDesktop

export default isDesktop
